/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

type Props = React.ImgHTMLAttributes<HTMLImageElement>;

const styles = {
  image: css`
    margin-top: 3rem;
    width: 100%;
    vertical-align: middle;
    object-fit: cover;
  `,
};

const BodyImage = ({ src, alt }: Props) => <img css={styles.image} src={src} alt={alt} loading="lazy" />;

export default BodyImage;
